export const StructuredSearchRoute = 'smart-form'
